import Ammo from "ammojs-typed";
import { Constants } from "./consts";
class PhysicsManager {
    gravity;
    collisionConfiguration;
    dispatcher;
    broadphase;
    solver;
    world;
    static instance;
    /**
     * PhysicsManager is the Physics engine.
     * @private
     */
    constructor() {
        this.gravity = new Ammo.btVector3(0, -Constants.GRAVITY, 0);
        this.collisionConfiguration = new Ammo.btDefaultCollisionConfiguration();
        this.dispatcher = new Ammo.btCollisionDispatcher(this.collisionConfiguration);
        this.broadphase = new Ammo.btDbvtBroadphase();
        this.solver = new Ammo.btSequentialImpulseConstraintSolver();
        this.world = new Ammo.btDiscreteDynamicsWorld(this.dispatcher, this.broadphase, this.solver, this.collisionConfiguration);
        this.world.setGravity(this.gravity);
    }
    get getWorld() {
        return this.world;
    }
    static getInstance() {
        if (!PhysicsManager.instance)
            PhysicsManager.instance = new PhysicsManager();
        return PhysicsManager.instance;
    }
}
export default PhysicsManager;
